import { FormlyFieldConfig } from '@ngx-formly/core';

export const STATES = [
  { label: 'NEW', value: 'NEW' },
  { label: 'SUBMITTED', value: 'SUBMITTED' },
  { label: 'PAYMENT_PENDING', value: 'PAYMENT_PENDING' },
  { label: 'PAYMENT_EXPIRED', value: 'PAYMENT_EXPIRED' },
  { label: 'PAID', value: 'PAID' },
  {
    label: 'PENDING_OFFICER_PROCESSING',
    value: 'PENDING_OFFICER_PROCESSING',
  },
  { label: 'APPROVED', value: 'APPROVED' },
  { label: 'REJECTED', value: 'REJECTED' },
  {
    label: 'PENDING_PUSH_TO_PARTNER',
    value: 'PENDING_PUSH_TO_PARTNER',
  },
  { label: 'PUSHED_TO_PARTNER', value: 'PUSHED_TO_PARTNER' },
  { label: 'PENDING_RESUBMISSION', value: 'PENDING_RESUBMISSION' },
  { label: 'PENDING_APPOINTMENT', value: 'PENDING_APPOINTMENT' },
  {
    label: 'PENDING_ASSIGN_OFFICE',
    value: 'PENDING_ASSIGN_OFFICE',
  },
  { label: 'RESUBMITTED', value: 'RESUBMITTED' },
  { label: 'ESCALATED', value: 'ESCALATED' },
  {
    label: 'PENDING_OFFICER_PROCESSING_LEVEL_1',
    value: 'PENDING_OFFICER_PROCESSING_LEVEL_1',
  },
  {
    label: 'PENDING_OFFICER_PROCESSING_LEVEL_2',
    value: 'PENDING_OFFICER_PROCESSING_LEVEL_2',
  },
  {
    label: 'PENDING_OFFICER_PROCESSING_LEVEL_3',
    value: 'PENDING_OFFICER_PROCESSING_LEVEL_3',
  },
  {
    label: 'PENDING_OFFICER_PROCESSING_LEVEL_4',
    value: 'PENDING_OFFICER_PROCESSING_LEVEL_4',
  },
  {
    label: 'PENDING_OFFICER_PROCESSING_LEVEL_5',
    value: 'PENDING_OFFICER_PROCESSING_LEVEL_5',
  },
  { label: 'RESUBMITTED_LEVEL_1', value: 'RESUBMITTED_LEVEL_1' },
  { label: 'RESUBMITTED_LEVEL_2', value: 'RESUBMITTED_LEVEL_2' },
  { label: 'RESUBMITTED_LEVEL_3', value: 'RESUBMITTED_LEVEL_3' },
  { label: 'RESUBMITTED_LEVEL_4', value: 'RESUBMITTED_LEVEL_4' },
  { label: 'RESUBMITTED_LEVEL_5', value: 'RESUBMITTED_LEVEL_5' },
  {
    label: 'PENDING_RESUBMISSION_LEVEL_1',
    value: 'PENDING_RESUBMISSION_LEVEL_1',
  },
  {
    label: 'PENDING_RESUBMISSION_LEVEL_2',
    value: 'PENDING_RESUBMISSION_LEVEL_2',
  },
  {
    label: 'PENDING_RESUBMISSION_LEVEL_3',
    value: 'PENDING_RESUBMISSION_LEVEL_3',
  },
  {
    label: 'PENDING_RESUBMISSION_LEVEL_4',
    value: 'PENDING_RESUBMISSION_LEVEL_4',
  },
  {
    label: 'PENDING_RESUBMISSION_LEVEL_5',
    value: 'PENDING_RESUBMISSION_LEVEL_5',
  },
];

export const EVENTS = [
  { label: 'APPLY', value: 'APPLY' },
  { label: 'PAY', value: 'PAY' },
  { label: 'INITIATE_PUSH', value: 'INITIATE_PUSH' },
  { label: 'ASSIGN_OFFICE', value: 'ASSIGN_OFFICE' },
  { label: 'PUSH', value: 'PUSH' },
  { label: 'APPROVE', value: 'APPROVE' },
  { label: 'REJECT', value: 'REJECT' },
  { label: 'ESCALATE', value: 'ESCALATE' },
  { label: 'SET_APPOINTMENT', value: 'SET_APPOINTMENT' },
  { label: 'REQUEST_FOR_ACTION', value: 'REQUEST_FOR_ACTION' },
  { label: 'EXPIRE_PAYMENT', value: 'EXPIRE_PAYMENT' },
  { label: 'SUBMIT_RFA', value: 'SUBMIT_RFA' },
  { label: 'APPROVE_WITH_FORM', value: 'APPROVE_WITH_FORM' },
  { label: 'TRANSITION', value: 'TRANSITION' },
];

export const ACTION_TYPES = [
  { label: 'BILL_ID_GENERATION', value: 'BILL_ID_GENERATION' },
  { label: 'NOTIFICATION', value: 'NOTIFICATION' },
  { label: 'INTEGRATION', value: 'INTEGRATION' },
  { label: 'GENERATE_CERTIFICATE', value: 'GENERATE_CERTIFICATE' },
  {
    label: 'REGISTER_EXTERNAL_CERTIFICATE',
    value: 'REGISTER_EXTERNAL_CERTIFICATE',
  },
  { label: 'URL_CALL', value: 'URL_CALL' },
  { label: 'OFFICE_ASSIGNMENT', value: 'OFFICE_ASSIGNMENT' },
  { label: 'FETCH_ID_PHOTO', value: 'FETCH_ID_PHOTO' },
  { label: 'SLOT_BOOKING', value: 'SLOT_BOOKING' },
  { label: 'SLOT_REBOOKING', value: 'SLOT_REBOOKING' },
  { label: 'REDEEM_SLOT', value: 'REDEEM_SLOT' },
  { label: 'INTERNAL_NOTIFICATION', value: 'INTERNAL_NOTIFICATION' },
  { label: 'FORM_FIELD_NOTIFICATION', value: 'FORM_FIELD_NOTIFICATION' },
  { label: 'EXECUTE_PRICING', value: 'EXECUTE_PRICING' },
  { label: 'APPLY_SERVICE', value: 'APPLY_SERVICE' },
  { label: 'TRIGGER_PARENT', value: 'TRIGGER_PARENT' },
  {
    label: 'SERVICE_CENTER_MASTER_BILL_ID_GENERATION',
    value: 'SERVICE_CENTER_MASTER_BILL_ID_GENERATION',
  },
  { label: 'UPDATE_DATASET', value: 'UPDATE_DATASET' },
  {
    label: 'TRIGGER_PARENT_SERVICE_EVENT',
    value: 'TRIGGER_PARENT_SERVICE_EVENT',
  },
  {
    label: 'TRIGGER_CHILD_SERVICE_EVENT',
    value: 'TRIGGER_CHILD_SERVICE_EVENT',
  },
];

export const OFFICE_ASSIGNMENT_TYPE = [
  { label: 'CODE_IN_APPLICATION_OFFICE', value: 'CODE_IN_APPLICATION_OFFICE' },
  { label: 'CODE_FIXED_OFFICE', value: 'CODE_FIXED_OFFICE' },
  { label: 'CODE_FROM_LOCATION', value: 'CODE_FROM_LOCATION' },
  { label: 'CODE_FROM_AN_EXPRESSION', value: 'CODE_FROM_AN_EXPRESSION' },
  {
    label: 'CODE_APPLICATION_FIELD_CODE',
    value: 'CODE_APPLICATION_FIELD_CODE',
  },
];

export const ROLES_ENDPOINT_URL = '/auth/v1/roles';
export const USERS_ENDPOINT_URL = '/auth/v1/search-users';

const REQUIRED_WHEN_VISIBLE =
  '!field?.props?.hideField && field?.props?.defaultRequired';

const hideUnlessActionType = (...actionTypes: string[]): string => {
  const visibleWhen = actionTypes
    .map(type => `field?.parent?.parent?.model?.actionType === '${type}'`)
    .join(' || ');
  return `!(${visibleWhen})`;
};

const baseArgField = (
  key: string,
  label: string,
  actionTypes: string[],
  props: Record<string, unknown> = {}
): FormlyFieldConfig => ({
  key,
  type: 'input',
  props: {
    label,
    disabled: false,
    required: false,
    placeholder: label,
    hint: '',
    tooltip: '',
    internalDescription: '',
    readonly: false,
    hidden: true,
    defaultRequired: false,
    ...props,
  },
  expressionProperties: {},
  validation: {
    messages: {
      required: 'Field is required',
    },
  },
  expressions: {
    hide: hideUnlessActionType(...actionTypes),
    'props.required': REQUIRED_WHEN_VISIBLE,
  },
  validators: {
    validation: [],
  },
});

const textArgField = (
  key: string,
  label: string,
  actionTypes: string[],
  props: Record<string, unknown> = {}
): FormlyFieldConfig => baseArgField(key, label, actionTypes, props);

const textareaArgField = (
  key: string,
  label: string,
  actionTypes: string[],
  description: string
): FormlyFieldConfig =>
  ({
    ...baseArgField(key, label, actionTypes, {
      rows: 3,
      description,
    }),
    type: 'textarea',
  } as FormlyFieldConfig);

const checkboxArgField = (
  key: string,
  label: string,
  actionTypes: string[]
): FormlyFieldConfig => ({
  key,
  type: 'checkbox',
  props: {
    label,
    description: label,
    indeterminate: false,
    default: false,
    defaultRequired: false,
  },
  validation: {
    messages: {},
  },
  expressions: {
    hide: hideUnlessActionType(...actionTypes),
    'props.required': REQUIRED_WHEN_VISIBLE,
  },
});

const dropdownArgField = (
  key: string,
  label: string,
  actionTypes: string[],
  options: { label: string; value: string }[]
): FormlyFieldConfig => ({
  key,
  type: 'customdropdown',
  props: {
    hint: '',
    label,
    options,
    tooltip: '',
    disabled: false,
    multiple: false,
    readonly: false,
    required: false,
    bindLabel: 'label',
    bindValue: 'value',
    placeholder: label,
    defaultRequired: false,
    internalDescription: '',
  },
  expressions: {
    hide: hideUnlessActionType(...actionTypes),
    'props.required': REQUIRED_WHEN_VISIBLE,
  },
  validation: {
    messages: {
      required: 'Field is required',
    },
  },
});

export const getStatiCtranslationFields = (
  defaultRequired: boolean
): FormlyFieldConfig[] => {
  return [
    {
      key: 'title',
      type: 'input',
      props: {
        label: 'Title',
        disabled: false,
        required: false,
        placeholder: 'Title',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
        hidden: true,
        defaultRequired: false,
      },
      expressionProperties: {},
      validation: {
        messages: {
          required: 'Field is required',
        },
      },
      validators: {
        validation: [],
      },
    },
    {
      key: 'smsBody',
      type: 'textarea',
      props: {
        label: 'SMS Body',
        disabled: false,
        required: defaultRequired,
        placeholder: 'SMS Body',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
        hidden: true,
        defaultRequired: defaultRequired,
      },

      expressionProperties: {},
      validation: {
        messages: {
          required: 'Field is required',
        },
      },
      validators: {
        validation: [],
      },
    },
    {
      key: 'subject',
      type: 'input',
      props: {
        label: 'Email Subject',
        disabled: false,
        required: defaultRequired,
        placeholder: 'Email Subject',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
        hidden: true,
        defaultRequired: defaultRequired,
      },

      expressionProperties: {},
      validation: {
        messages: {
          required: 'Field is required',
        },
      },
      validators: {
        validation: [],
      },
    },
    {
      key: 'emailBody',
      type: 'customricheditor',
      props: {
        label: 'Email Body',
        disabled: false,
        required: defaultRequired,
        placeholder: 'Email Body',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
        hidden: true,
        defaultRequired: defaultRequired,
        styles: {
          height: '300px',
        },
      },

      expressionProperties: {},
      validation: {
        messages: {
          required: 'Field is required',
        },
      },
      validators: {
        validation: [],
      },
    },
  ];
};

export const getDynamicTranslationFields = (
  defaultRequired: boolean
): FormlyFieldConfig[] => {
  const notificationTemplateDropdown = (
    type: 'EMAIL' | 'SMS'
  ): Partial<FormlyFieldConfig> => ({
    type: 'customdropdownpaginated',
    props: {
      bindLabel: 'templateName',
      bindValue: 'templateName',
      useBaseUrl: true,
      dataset: {
        url: '/notification/v1/service-templates',
        httpMethod: 'GET',
        dataField: 'data.templates',
        totalPagesKey: 'totalPages',
        currentPageKey: 'number',
        searching: true,
        searchField: 'name',
        params: {
          page: 0,
          pageSize: 30,
          type,
        },
      },
    },
  });
  const emailTemplateDropdown = notificationTemplateDropdown('EMAIL');
  const smsTemplateDropdown = notificationTemplateDropdown('SMS');

  return [
    {
      key: 'emailTemplateName',
      ...emailTemplateDropdown,
      props: {
        ...emailTemplateDropdown.props,
        label: 'Email Template Name',
        disabled: false,
        required: defaultRequired,
        placeholder: 'Search email template',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
        hidden: true,
        defaultRequired: defaultRequired,
      },
      expressionProperties: {},
      validation: {
        messages: {
          required: 'Field is required',
        },
      },
      validators: {
        validation: [],
      },
    },
    {
      key: 'smsTemplateName',
      ...smsTemplateDropdown,
      props: {
        ...smsTemplateDropdown.props,
        label: 'SMS Template Name',
        disabled: false,
        required: defaultRequired,
        placeholder: 'Search SMS template',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
        hidden: true,
        defaultRequired: defaultRequired,
      },

      expressionProperties: {},
      validation: {
        messages: {
          required: 'Field is required',
        },
      },
      validators: {
        validation: [],
      },
    },
  ];
};

export const getStateActionFields = (services: any[]): FormlyFieldConfig[] => {
  return [
    {
      key: 'actionType',
      type: 'customdropdown',
      props: {
        label: 'Action Type',
        disabled: false,
        required: false,
        placeholder: 'Action Type',
        options: ACTION_TYPES,
        multiple: false,
        bindValue: 'value',
        bindLabel: 'label',
        hint: '',
        tooltip: '',
        internalDescription: '',
        readonly: false,
      },
      expressions: {},
      validation: {
        messages: {},
      },
    },
    {
      key: 'args',
      type: 'formly-group',
      fieldGroup: [
        {
          key: 'notificationType',
          type: 'customdropdown',
          props: {
            hint: '',
            label: 'Notification Type',
            options: [
              { label: 'STATIC', value: 'STATIC' },
              {
                label: 'NOTIFICATION_ENGINE_TEMPLATE',
                value: 'NOTIFICATION_ENGINE_TEMPLATE',
              },
            ],
            tooltip: '',
            disabled: false,
            multiple: false,
            readonly: false,
            required: true,
            bindLabel: 'label',
            bindValue: 'value',
            placeholder: 'Select Notification Type',
            defaultRequired: true,
            internalDescription: '',
          },
          defaultValue: null,
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'NOTIFICATION')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'Notification Type is required',
            },
          },
        },
        {
          key: 'staticTemplate',
          type: 'formly-group',
          fieldGroup: [
            {
              key: 'en',
              type: 'formly-group',
              wrappers: ['custom-expansion-panel-with-icon'],
              props: {
                label: 'English Notification Template',
                iconName: 'bell',
              },
              fieldGroup: [...getStatiCtranslationFields(true)],
            },
            {
              key: 'fr',
              type: 'formly-group',
              wrappers: ['custom-expansion-panel-with-icon'],
              props: {
                label: 'French Notification Template',
                iconName: 'bell',
              },
              fieldGroup: [...getStatiCtranslationFields(false)],
            },
            {
              key: 'kin',
              type: 'formly-group',
              wrappers: ['custom-expansion-panel-with-icon'],
              props: {
                label: 'Kinyarwanda Notification Template',
                iconName: 'bell',
              },
              fieldGroup: [...getStatiCtranslationFields(false)],
            },
          ],
          expressions: {
            hide: "!(field?.parent?.parent?.model?.args?.notificationType === 'STATIC')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'Notification Type is required',
            },
          },
        },
        {
          key: 'dynamicTemplate',
          type: 'formly-group',
          fieldGroup: [
            {
              key: 'en',
              type: 'formly-group',
              wrappers: ['custom-expansion-panel-with-icon'],
              props: {
                label: 'English Notification Template',
              },
              fieldGroup: [...getDynamicTranslationFields(true)],
            },
            {
              key: 'fr',
              type: 'formly-group',
              wrappers: ['custom-expansion-panel-with-icon'],
              props: {
                label: 'French Notification Template',
              },
              fieldGroup: [...getDynamicTranslationFields(false)],
            },
            {
              key: 'kin',
              type: 'formly-group',
              wrappers: ['custom-expansion-panel-with-icon'],
              props: {
                label: 'Kinyarwanda Notification Template',
              },
              fieldGroup: [...getDynamicTranslationFields(false)],
            },
          ],
          expressions: {
            hide: "!(field?.parent?.parent?.model?.args?.notificationType === 'NOTIFICATION_ENGINE_TEMPLATE')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'Notification Type is required',
            },
          },
        },
        textareaArgField(
          'attachment',
          'Notification Attachments',
          ['NOTIFICATION'],
          'JSON array of notification attachments, for example [{"sourceType":"FORM_FIELD","attachmentFields":["file"]}].'
        ),
        textareaArgField(
          'internalEmailNotificationRecipients',
          'Internal Email Recipients',
          ['INTERNAL_NOTIFICATION'],
          'Enter one recipient email per line, or separate values with commas.'
        ),
        textareaArgField(
          'internalSmsNotificationRecipients',
          'Internal SMS Recipients',
          ['INTERNAL_NOTIFICATION'],
          'Enter one recipient phone number per line, or separate values with commas.'
        ),
        textareaArgField(
          'formFieldsSmsNotificationRecipients',
          'SMS Recipient Form Fields',
          ['FORM_FIELD_NOTIFICATION'],
          'Enter one form field key per line, or separate values with commas.'
        ),
        textareaArgField(
          'formFieldsEmailNotificationRecipients',
          'Email Recipient Form Fields',
          ['FORM_FIELD_NOTIFICATION'],
          'Enter one form field key per line, or separate values with commas.'
        ),
        {
          key: 'endpointCode',
          type: 'input',
          props: {
            label: 'Endpoint Code',
            disabled: false,
            required: true,
            placeholder: 'Endpoint Code',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: true,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: hideUnlessActionType(
              'INTEGRATION',
              'INTEGRATION_UPDATE',
              'URL_CALL',
              'FETCH_ID_PHOTO'
            ),
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'async',
          type: 'checkbox',
          props: {
            label: 'Async',
            description: 'Is endpoint async?',
            pattern: 'true',
            indeterminate: false,
            default: false,
          },
          validation: {
            messages: {
              pattern: 'Please accept the terms',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'INTEGRATION')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
        },
        textareaArgField(
          'parametersToRetain',
          'Response values to save',
          [
            'INTEGRATION_UPDATE',
            'TRIGGER_PARENT_SERVICE_EVENT',
            'TRIGGER_CHILD_SERVICE_EVENT',
          ],
          'Map response JSONata expressions to application detail keys. Normal integrations save response applicationDetails automatically.'
        ),

        {
          key: 'fetchValueAttribute',
          type: 'input',
          props: {
            label: 'Fetch Value Attribute',
            disabled: false,
            required: true,
            placeholder: 'Fetch Value Attribute',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: true,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: hideUnlessActionType('FETCH_ID_PHOTO'),
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'fetchValueTypeAttribute',
          type: 'input',
          props: {
            label: 'Fetch Value Type Attribute',
            disabled: false,
            required: true,
            placeholder: 'Fetch Value Type Attribute',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: true,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: hideUnlessActionType('FETCH_ID_PHOTO'),
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'certificateName',
          type: 'input',
          props: {
            label: 'Certificate Name',
            disabled: false,
            required: true,
            placeholder: 'Certificate Name',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: true,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: hideUnlessActionType(
              'GENERATE_CERTIFICATE',
              'REGISTER_EXTERNAL_CERTIFICATE'
            ),
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'certificateTemplateCode',
          type: 'input',
          props: {
            label: 'Certificate Code',
            disabled: false,
            required: true,
            placeholder: 'Certificate Code',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: true,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'GENERATE_CERTIFICATE')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'certificateExpirationDays',
          type: 'input',
          props: {
            label: 'Certificate Expiration Days',
            disabled: false,
            required: true,
            placeholder: 'Certificate Expiration Days',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: true,
            type: 'number',
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'GENERATE_CERTIFICATE')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        textArgField('attachmentKey', 'Attachment Key', [
          'GENERATE_CERTIFICATE',
          'REGISTER_EXTERNAL_CERTIFICATE',
        ]),
        textareaArgField(
          'certificateNames',
          'Certificate Names',
          ['GENERATE_CERTIFICATE'],
          'JSON object or key=value lines, for example en-US=Certificate.'
        ),
        textArgField(
          'reminderOffsetDays',
          'Reminder Offset Days',
          ['GENERATE_CERTIFICATE'],
          { type: 'number' }
        ),
        checkboxArgField('certificateWithList', 'Certificate With List', [
          'GENERATE_CERTIFICATE',
        ]),
        textareaArgField(
          'reminderNotifications',
          'Reminder Notifications',
          ['GENERATE_CERTIFICATE'],
          'JSON object with notificationType and staticTemplate/dynamicTemplate.'
        ),

        // Fields for OFFICE_ASSIGNMENT
        {
          key: 'officeAssignmentType',
          type: 'customdropdown',
          props: {
            hint: '',
            label: 'Office Assignment Type',
            options: OFFICE_ASSIGNMENT_TYPE,
            tooltip: '',
            disabled: false,
            multiple: false,
            readonly: false,
            required: true,
            bindLabel: 'label',
            bindValue: 'value',
            placeholder: 'Select Office Assignment Type',
            defaultRequired: true,
            internalDescription: '',
          },
          defaultValue: null,
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'OFFICE_ASSIGNMENT')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'field is required',
            },
          },
        },
        {
          key: 'officeId',
          type: 'input',
          props: {
            label: 'Office ID',
            disabled: false,
            required: true,
            placeholder: 'Office ID',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: false,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'OFFICE_ASSIGNMENT')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'officeLevel',
          type: 'input',
          props: {
            label: 'Office LEVEL',
            disabled: false,
            required: false,
            placeholder: 'Office LEVEL',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: false,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'OFFICE_ASSIGNMENT')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'formFieldKey',
          type: 'input',
          props: {
            label: 'Form Field Key',
            disabled: false,
            required: true,
            placeholder: 'Form Field Key',
            hint: '',
            tooltip: '',
            internalDescription: '',
            readonly: false,
            hidden: true,
            defaultRequired: false,
          },
          expressionProperties: {},
          validation: {
            messages: {
              required: 'Field is required',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'OFFICE_ASSIGNMENT')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validators: {
            validation: [],
          },
        },
        textareaArgField(
          'formFieldKeys',
          'Form Field Keys',
          ['OFFICE_ASSIGNMENT'],
          'Enter one form field key per line, or separate values with commas.'
        ),
        textArgField('fixedOfficeCode', 'Fixed Office Code', [
          'OFFICE_ASSIGNMENT',
        ]),
        textArgField(
          'officeAssignmentExpression',
          'Office Assignment Expression',
          ['OFFICE_ASSIGNMENT']
        ),
        textArgField('groupIdField', 'Group ID Field', [
          'SLOT_BOOKING',
          'SLOT_REBOOKING',
          'REDEEM_SLOT',
        ]),
        textArgField('timeRangeIdField', 'Time Range ID Field', [
          'SLOT_BOOKING',
          'SLOT_REBOOKING',
          'REDEEM_SLOT',
        ]),
        textArgField('seatsField', 'Seats Field', ['SLOT_BOOKING']),
        textArgField('invoiceDescription', 'Invoice Description', [
          'BILL_ID_GENERATION',
        ]),
        textArgField('currency', 'Currency', [
          'BILL_ID_GENERATION',
          'EXECUTE_PRICING',
          'MASTER_BILL_ID_GENERATION',
          'SERVICE_CENTER_MASTER_BILL_ID_GENERATION',
        ]),
        textArgField('event', 'Event', [
          'TRIGGER_PARENT',
          'TRIGGER_PARENT_SERVICE_EVENT',
          'TRIGGER_CHILD_SERVICE_EVENT',
        ]),
        textArgField('serviceCenterId', 'Service Center ID', [
          'SERVICE_CENTER_MASTER_BILL_ID_GENERATION',
        ]),
        textArgField('datasetCode', 'Dataset Code', ['UPDATE_DATASET']),
        dropdownArgField(
          'datasetUpdateType',
          'Dataset Update Type',
          ['UPDATE_DATASET'],
          [{ label: 'SEQUENTIAL_UPDATE', value: 'SEQUENTIAL_UPDATE' }]
        ),
        textareaArgField(
          'datasetFieldsMapping',
          'Dataset Fields Mapping',
          ['UPDATE_DATASET'],
          'JSON object or key=value lines for dataset item fields.'
        ),

        // Fields for APPLY_SERVICE
        {
          key: 'serviceCode',
          type: 'customdropdownpaginated',
          props: {
            label: 'Service',
            options: [],
            useBaseUrl: true,
            required: true,
            bindLabel: 'serviceName',
            bindValue: 'serviceCode',
            placeholder: 'Select Service',
            internalDescription: 'Select the service to apply',
            dataset: {
              url: '/service/api/v1/services',
              params: { size: 50, page: 0 },
              dataField: 'data.content',
              pagination: 'true',
              searching: 'true',
              searchField: 'serviceName',
            },
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'APPLY_SERVICE')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'Service is required',
            },
          },
        },
        {
          key: 'applyPayload',
          type: 'customexpansionrepeater',
          props: {
            addText: 'Add Field Mapping',
            label: 'Apply Payload',
            titleFieldName: 'key',
            description: 'Map fields between services',
          },
          expressions: {
            hide: "!(field?.parent?.parent?.model?.actionType === 'APPLY_SERVICE')",
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'key',
                type: 'customdropdown',
                props: {
                  label: 'Target Field',
                  required: true,
                  placeholder: 'Select target field',
                  options: [],
                  bindLabel: 'fieldLabel',
                  bindValue: 'fieldName',
                },
                expressions: {
                  'props.options': field => {
                    // Get reference to the root model
                    const model = field.options?.formState?._rootModel || {};

                    // Get the service code from the parent action
                    const getServiceCode = () => {
                      const parentField = field.parent?.parent?.parent?.parent;
                      if (
                        parentField &&
                        parentField.model &&
                        parentField.model.args
                      ) {
                        return parentField.model.args.serviceCode;
                      }
                      return null;
                    };

                    const serviceCode = getServiceCode();
                    if (serviceCode) {
                      // The serviceCode is used as a key in model to store the fields
                      const cacheKey = 'serviceCode';
                      const serviceFields = model[cacheKey];

                      if (serviceFields && Array.isArray(serviceFields)) {
                        return serviceFields;
                      }
                    }

                    return [];
                  },
                },
                validation: {
                  messages: {
                    required: 'Target field is required',
                  },
                },
              },
              {
                key: 'value',
                type: 'input',
                props: {
                  label: 'Source Value',
                  required: true,
                  placeholder: 'Use fieldKey or $service{serviceId}.fieldName',
                  description:
                    'Use fieldKey in this form for current service or $service{serviceId}.fieldName for another service',
                },
                validation: {
                  messages: {
                    required: 'Source value is required',
                  },
                },
              },
            ],
          },
        },
      ],
    },
  ];
};

export const getEndStateFields = (
  stateLabel: string,
  key: string,
  fetchedStates: any[],
  services: any[]
): FormlyFieldConfig[] => {
  return [
    {
      props: {
        label: stateLabel,
        disabled: false,
        placeholder: '',
      },
      expressions: {},
      validation: {
        messages: {},
      },
      fieldGroup: [
        {
          key: 'stateName',
          type: 'input',
          props: {
            hint: '',
            label: 'State Name',
            tooltip: '',
            disabled: false,
            readonly: false,
            required: true,
            defaultRequired: key === 'endStateOne' ? true : false,
            minLength: 2,
            placeholder: ' State Name',
            internalDescription: '',
          },
          defaultValue: null,
          expressions: {
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'Field is required',
              minLength: 'Minimum length not met',
            },
          },
          validators: {
            validation: [],
          },
        },
        {
          key: 'stateCode',
          type: 'customdropdownpaginated',
          props: {
            hint: '',
            label: 'State Code',
            options: [],
            tooltip: '',
            disabled: false,
            multiple: false,
            readonly: false,
            required: true,
            bindLabel: 'stateName',
            bindValue: 'stateName',
            placeholder: 'Select State Code',
            defaultRequired: key === 'endStateOne' ? true : false,
            useBaseUrl: true,
            internalDescription: '',
            dataset: {
              url: '/application/v1/application-states/paginated',
              params: { size: 50, page: 0 },
              dataField: 'data.content',
              pagination: 'true',
              searching: 'true',
              searchField: 'searchTerm',
              sortDirection: 'asc',
              sort: 'stateName',
            },
          },
          defaultValue: null,
          expressions: {
            'props.required':
              '!field?.props?.hideField && field?.props?.defaultRequired',
          },
          validation: {
            messages: {
              required: 'Start State is required',
            },
          },
        },
        {
          key: 'nextEvent',
          type: 'customdropdown',
          props: {
            hint: '',
            label: 'Next Event',
            options: EVENTS,
            tooltip: '',
            disabled: false,
            multiple: false,
            readonly: false,
            required: false,
            bindLabel: 'label',
            bindValue: 'value',
            placeholder: 'Next Event',
            internalDescription: '',
          },
          defaultValue: null,
          validation: {
            messages: {
              required: 'Next Event is required',
            },
          },
        },
        {
          key: 'nonBreakingActions',
          type: 'customexpansionrepeater',
          props: {
            addText: 'Add Non-Breaking Actions',
            label: 'Non Breaking Actions',
            placeholder: '',
            disabled: false,
            titleFieldName: 'actionType',
          },
          expressions: {},
          validation: {
            messages: {},
          },
          fieldArray: {
            fieldGroup: [...getStateActionFields(services)],
          },
        },
        {
          key: 'breakingActions',
          type: 'customexpansionrepeater',
          props: {
            addText: 'Add Breaking Actions',
            label: 'Breaking Actions',
            placeholder: '',
            disabled: false,
            titleFieldName: 'actionType',
          },
          expressions: {},
          validation: {
            messages: {},
          },
          fieldArray: {
            fieldGroup: [...getStateActionFields(services)],
          },
        },
      ],
    },
  ];
};

export const getAuthorisationFields = (): FormlyFieldConfig[] => {
  const isUserAuthorized = "model.authMode === 'USER_AUTHORIZED'";

  return [
    {
      props: {
        label: 'Transition Authorization',
        disabled: false,
        placeholder: '',
        hideHeader: true,
      },
      expressions: {},
      validation: {
        messages: {},
      },
      fieldGroup: [
        {
          key: 'authMode',
          type: 'radio',
          defaultValue: 'USER_AUTHORIZED',
          className: 'auth-mode-radio auth-mode-radio--user',
          props: {
            label: 'User authorized',
            required: true,
            hideLabel: true,
            options: [{ label: 'User authorized', value: 'USER_AUTHORIZED' }],
          },
          validation: {
            messages: {
              required: 'Authorization mode is required',
            },
          },
        },
        {
          className: 'auth-user-children',
          fieldGroup: [
            {
              key: 'roleBased',
              type: 'checkbox',
              defaultValue: false,
              className: 'auth-checkbox',
              props: {
                label: 'Role Based',
                indeterminate: false,
                hideLabel: true,
              },
            },
            {
              key: 'anyAuthenticatedUser',
              type: 'checkbox',
              defaultValue: false,
              className: 'auth-sub-checkbox',
              props: {
                label: 'Any authenticated user',
                indeterminate: false,
                description: 'Allow any authenticated user (ANY_ROLE)',
                hideLabel: true,
              },
              expressions: {
                hide: '!model.roleBased',
              },
            },
            {
              key: 'authorisedRoles',
              type: 'customdropdownpaginated',
              defaultValue: [],
              className: 'auth-paginated-select',
              props: {
                label: 'Roles',
                placeholder: 'Search and select roles...',
                multiple: true,
                options: [],
                bindLabel: 'name',
                bindValue: 'name',
                useBaseUrl: true,
                defaultRequired: true,
                internalDescription: '',
                dataset: {
                  url: ROLES_ENDPOINT_URL,
                  params: { size: 50, page: 0 },
                  dataField: 'data.content',
                  pagination: 'true',
                  searching: 'true',
                  searchField: 'searchTerm',
                  sortDirection: 'asc',
                  sort: 'name',
                },
              },
              expressions: {
                hide: '!model.roleBased || model.anyAuthenticatedUser',
                'props.required':
                  '!field?.props?.hideField && field?.props?.defaultRequired',
              },
              validation: {
                messages: {
                  required: 'At least one role is required',
                },
              },
            },
            {
              key: 'userBased',
              type: 'checkbox',
              defaultValue: false,
              className: 'auth-checkbox',
              props: {
                label: 'User Based',
                indeterminate: false,
                hideLabel: true,
              },
            },
            {
              key: 'authorisedUsers',
              // Custom-built Formly type that exposes ng-select's label
              // template slots so we can render "First Last (email)" from the
              // raw API fields, without an HTTP interceptor or backend change.
              type: 'customdropdownpaginatedwithtemplate',
              defaultValue: [],
              className: 'auth-paginated-select',
              props: {
                label: 'Users',
                placeholder: 'Search and select users...',
                multiple: true,
                options: [],
                bindValue: 'id',
                useBaseUrl: true,
                defaultRequired: true,
                internalDescription: '',
                labelFn: (item: Record<string, unknown>): string => {
                  const first = String(item['firstName'] ?? '').trim();
                  const last = String(item['lastName'] ?? '').trim();
                  const email = String(item['email'] ?? '').trim();
                  const username = String(item['username'] ?? '').trim();
                  const fullName = [first, last].filter(Boolean).join(' ');
                  if (fullName && email) return `${fullName} (${email})`;
                  if (fullName) return fullName;
                  if (email) return email;
                  if (username) return username;
                  return String(item['id'] ?? '');
                },
                dataset: {
                  url: USERS_ENDPOINT_URL,
                  params: { size: 50, page: 0 },
                  dataField: 'data',
                  searchField: 'searchTerm',
                  sortDirection: 'asc',
                  sort: 'email',
                },
              },
              expressions: {
                hide: '!model.userBased',
                'props.required':
                  '!field?.props?.hideField && field?.props?.defaultRequired',
              },
              validation: {
                messages: {
                  required: 'At least one user is required',
                },
              },
            },
          ],
          expressions: {
            hide: `!(${isUserAuthorized})`,
          },
        },
        {
          key: 'authMode',
          type: 'radio',
          className: 'auth-mode-radio auth-mode-radio--system',
          props: {
            label: 'System Authorized',
            hideLabel: true,
            options: [
              { label: 'System Authorized', value: 'SYSTEM_AUTHORIZED' },
            ],
          },
        },
      ],
    },
  ];
};
